// extracted by mini-css-extract-plugin
module.exports = {"info":"_bb","dealer":"_bc","dealerName":"_bd","dealerAddress":"_be","actions":"_bf","button":"_bg"};